/* eslint-disable spaced-comment */
//vendors
import React from 'react';
import { Switch, HashRouter } from 'react-router-dom';
import { Redirect, Route } from 'react-router';

//Styles
import { GlobalStyle } from './style';

//Pages
import Home from './pages/Home';
import LoginPilot from './pages/LoginPilot';
import AboutDFS from './pages/AboutDFS';
import Privacy from './pages/Privacy';
import ContactUs from './pages/ContactUs';
import Sitemap from './pages/Sitemap';
import FAQ from './pages/FAQ';
import NoMatch from './pages/NoMatch';
import ErrorPage from './pages/ErrorPage';
import SendUsMessage from './pages/SendUsMessage';

//Contexts
import { PrivacyProvider } from './contexts/PrivacyContext';
import { AboutDFSProvider } from './contexts/AboutDFSContext';
import { ContactUsProvider } from './contexts/ContactUsContext';
import { HomeProvider } from './contexts/HomeContext';
import { ConfigProvider } from './contexts/ConfigContext';
import { SendUsMessageProvider } from './contexts/SendUsMessageContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { LabelsProvider } from './contexts/LabelsContext';
import { UserProvider } from './contexts/UserContext';
import { SignInProvider } from './contexts/SignInContext';

//Components
import Layout from './components/Layout';
import Analytics from './components/Analytics';
import Boomerang from './components/Boomerang';
import Omniture from './components/Omniture';
import MBox from './components/MBox';

function App() {
  return (
    <HashRouter>
      <ConfigProvider>
        <LanguageProvider>
          <UserProvider>
            <LabelsProvider>
              <SignInProvider>
                <Layout>
                  <GlobalStyle />
                  <Analytics />
                  <Boomerang />
                  <Omniture />
                  <MBox />
                  <Switch>
                    <HomeProvider exact path="/">
                      <Route component={Home} title="Home" />
                    </HomeProvider>
                    <Route exact path="/login" component={LoginPilot}/>
                    <Route exact path="/login-pilot" component={() => (
                      <Redirect to="/login"/>
                    )}/>
                    <Route
                      exact
                      path="/about-dfs"
                      title="About DFS"
                      component={() => (
                        <AboutDFSProvider>
                          <AboutDFS />
                        </AboutDFSProvider>
                      )}
                    />
                    <Route exact path="/faq" component={FAQ} title="FAQ" />
                    <Route exact path="/faq/:category" component={FAQ} title="FAQ" />
                    <Route exact path="/faq/:category/search/:term" component={FAQ} title="FAQ" />
                    <Route
                      exact
                      path="/faq/:category/:questionCategory"
                      component={FAQ}
                      title="FAQ"
                    />
                    <Route
                      exact
                      path="/forgot-password"
                      component={() => <Redirect to="/"/>}
                      title="Forgot Password"
                    />
                    <Route
                      exact
                      path="/change-password"
                      component={() => <Redirect to="/"/>}
                      title="Forgot Password"
                    />
                    <Route
                      exact
                      path="/privacy"
                      component={() => (
                        <PrivacyProvider>
                          <Privacy />
                        </PrivacyProvider>
                      )}
                    />
                    <Route
                      exact
                      path="/contact-us"
                      component={() => (
                        <ContactUsProvider>
                          <ConfigProvider>
                            <ContactUs />
                          </ConfigProvider>
                        </ContactUsProvider>
                      )}
                    />
                    <Route exact path="/sitemap" component={Sitemap} />
                    <Route
                      exact
                      path="/signup"
                      component={() => <Redirect to="/"/>}
                    />
                     <Route
                      exact
                      path="/login/signup"
                      component={() => <Redirect to="/login"/>}
                    />
                    <Route
                      exact
                      path="/send-us-message"
                      component={() => (
                        <SendUsMessageProvider>
                          <SendUsMessage />
                        </SendUsMessageProvider>
                      )}
                    />
                    <Route exact path="/error" component={ErrorPage} />
                    <Route component={NoMatch} />
                  </Switch>
                </Layout>
              </SignInProvider>
            </LabelsProvider>
          </UserProvider>
        </LanguageProvider>
      </ConfigProvider>
    </HashRouter>
  );
}

export default App;
